module.exports = __webpack_public_path__ + "static/media/banner.ba78eef3.png";